<%
  // The record the modal's interactions are attributed to: the resource it was opened for, the finder's physician,
  // or the fetched resource once it arrives (the only identity a location result passes on).
  var analyticsRecord = filters.resource_type && filters.resource_id ? [filters.resource_type, filters.resource_id]
    : filters.physician_id ? ['Physician', filters.physician_id]
    : resource.type && resource.id ? [resource.type, resource.id] : null;
  var analyticsRecordAttributes = analyticsRecord ? `data-resource-type="${analyticsRecord[0]}" data-resource-id="${analyticsRecord[1]}"` : '';
%>
<header class="appointment-header">
  <h3 class="appointment-header-title-text"><%= title ? title : `${I18n.header.title} ${resource.name}` %></h3>
</header>

<div class="appointment-header-items" <%= analyticsRecordAttributes %>>
  <% if (options.patientTypeSelector !== false) { %>
    <div class="appointment-header-item appointment-filter-patient-type">
      <sp-slot-picker-filter>
        <sp-select class="js-patient-type" value="<%= filters.patient_type %>" data-analytics-element="slot-picker-patient-type" data-analytics-interaction="select"></sp-select>
      </sp-slot-picker-filter>
    </div>
  <% } %>

  <% if (options.availabilitySelector !== false) { %>
    <div class="appointment-header-item appointment-filter-visit-types">
      <sp-slot-picker-filter>
        <sp-quantum-select
            class="js-visit-types"
            data-analytics-element="slot-picker-visit-type"
            data-analytics-interaction="select"
            navigation="accordion"
            selectable-branches
            branch-toggle-label="<%= I18n.filters.visit_types.toggle_category %>"
            close-on-select
            hide-search-bar
            max-height="325px"
            selected-prepend-icon="check-alt-color"
        >
          <sp-text-field
              slot="activator"
              class="js-visit-types-display"
              inputmode="none"
              readonly
              density="compact"
              propagate-append-click
              placeholder="<%= I18n.filters.visit_types.prompt %>"
          >
            <sp-caret slot="append" class="js-visit-types-caret"></sp-caret>
          </sp-text-field>
        </sp-quantum-select>
      </sp-slot-picker-filter>
    </div>

    <div class="appointment-header-item appointment-filter-time">
      <sp-slot-picker-filter>
        <sp-select class="js-available-times" value="<%= filters.available_times %>" data-analytics-element="slot-picker-available-time" data-analytics-interaction="select"></sp-select>
      </sp-slot-picker-filter>
    </div>
  <% } %>

  <% if (options.addressSelector !== false && resource.addresses.length > 1) { %>
    <div class="appointment-header-item address-select">
      <sp-slot-picker-filter>
        <sp-select class="js-resource-location" value="<%= filters.department_id %>" data-analytics-element="slot-picker-location" data-analytics-interaction="select"></sp-select>
      </sp-slot-picker-filter>
    </div>
  <% } %>
</div>

<% if (showNav) { %>
  <nav class="appointment-navigator" <%= analyticsRecordAttributes %>>
    <div class="appointment-navigator-items">
      <div class="appointment-navigator-item appointment-navigator-nav">
        <% _.each(views, function (view) { %>
          <div
              class="<%- classNames({'appointment-navigator-nav-item': true, 'active': selectedView === view.name}) %>"
              tabindex="0"
              data-appointment-booking-slot-picker-modal-behaviour="show-view" data-view="<%- view.name %>"
              data-analytics-element="slot-picker-view-toggle"
              data-analytics-interaction="toggle" data-analytics-value="<%- view.name %>"
          >
            <%- view.title %>
          </div>
        <% }) %>
      </div>
    </div>
  </nav>
<% } %>
